import { addDays } from 'date-fns'
import { IUserAccountStore } from './index'

export default {
  credentials: {},
  infoModal: {
    open: false,
  },
  isAuthorizing: null,
  license: {
    isLoading: true,
    items: [
      {
        license: addDays(new Date(), 1),
        licenseType: 1,
      },
    ],
  },
  limitModal: {
    open: false,
  },
  limits: {
    addLimit: 6,
    copyLimit: 3,
    editLimit: 6,
    transferLimit: 3,
  },
  notifications: {
    hasMore: false,
    isLoading: false,
    items: [],
    seen: false,
  },
  request: {
    errMessage: '',
    isLoading: false,
  },
  sliderTab: 0,
  deleteError: false,
  cookies: {
    open: false,
    forceSave: false,
    step: 0
  },
  user: {
    newUserDate: new Date(1622332800000), //2021.05.30 Data od której konta są traktowane jako nowe
    serverTime: new Date(), //Temp
    userOffset: new Date().getTimezoneOffset(),
    userTime: new Date(),
  },
} as IUserAccountStore
